import { render } from "./ChartPlaceholder.vue?vue&type=template&id=388a2a74"
import script from "./ChartPlaceholder.vue?vue&type=script&lang=js"
export * from "./ChartPlaceholder.vue?vue&type=script&lang=js"

import "./ChartPlaceholder.vue?vue&type=style&index=0&id=388a2a74&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__